import { render, staticRenderFns } from "./singlePT.vue?vue&type=template&id=111920ec&scoped=true&"
import script from "./singlePT.vue?vue&type=script&lang=js&"
export * from "./singlePT.vue?vue&type=script&lang=js&"
import style0 from "./singlePT.vue?vue&type=style&index=0&id=111920ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111920ec",
  null
  
)

export default component.exports